
import { Component, Vue } from "vue-property-decorator";
import Logo from "./components/Logo.vue";
import ContractPopup from "./components/ContractPopup.vue";
import { forgetPasswordReset, login } from "@/api/login";
import { encryptData } from "@/utils/encryptData";
import { enterSystem } from './login'
import store from '@/store'
import { setAllowsBackGesture } from "@/utils/h5ToApp";

@Component({
  components: { Logo, ContractPopup }
})
export class ResetPwd extends Vue {
  pwd1 = ''
  pwd2 = ''
  pwdFieldType = 'password'
  errShakeClass = 'animate__animated animate__headShake'
  isPwd2Err = false
  pwd2ErrMsg = '两次密码不一致'
  isAgree = false

  created () {
    this.$store.commit('addKeepAlive', 'ResetPwd')
  }

  mounted () {
    // 禁用侧滑返回
    setAllowsBackGesture('0');
  }

  handleBack () {
    this.$router.replace('/pwdLogin')
    this.$store.commit('delKeepAlive', 'ResetPwd')
  }

  // input输入限制（英文、数字）独立编码
  formatterInput (value) {
    return value.replace(/[^a-zA-Z\d]/g, "")
  }

  onPwdInput () {
    this.isPwd2Err && (this.isPwd2Err = false)
  }

  toPath (path: string) {
    this.$router.push(path)
  }

  onSubmit () {
    if (this.pwd1 != this.pwd2) {
      this.pwd2ErrMsg = '两次密码不一致'
      this.isPwd2Err = true
      return
    }
    if (!this.isAgree) {
      (this.$refs.contractPopupRef as any).showPopup()
      return
    }
    const { businessId, mobile, smsCode } = this.$route.query as any
    if (!businessId) {
      this.$toast("请先获取验证码");
      return
    }
    const resetParams = {
      businessId,
      mobile: encryptData(mobile),
      smsCode,
      password: encryptData(this.pwd1)
    }
    // 重置密码
    forgetPasswordReset(resetParams).then(() => {
      this.$toast("密码重置成功");
      const loginParams = {
        username: encryptData(mobile),
        password: encryptData(this.pwd1)
      }
      // 用新密码无感登录
      login(loginParams).then((res) => {
        // 缓存信息
        store.dispatch('GetInfo', res.data)
        store.dispatch('setFirstUserId', res.data.userId)
        this.$store.commit('delKeepAlive', 'ResetPwd')
        // 登录账号和密码存储，下次登录回填
        store.dispatch('setLoginInfo', { mobile, password: this.pwd1 })
        // 进入系统
        enterSystem('resetPwd')
      })
    }).catch((err) => {
      // 有误
      const { msg = '请联系管理员' } = err.data || null
      this.pwd2ErrMsg = msg
      this.isPwd2Err = true
    })
  }

  onYesContract () {
    this.isAgree = true
    this.onSubmit()
  }
}
export default ResetPwd
